import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextAreaField, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IUserContentReviewNotifyFormValues } from './UserContentReviewNotifyForm';
import { FormDateField } from '~/components/atoms/fields/DateField';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type IUserContentReviewNotifyFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IUserContentReviewNotifyFormValues>;
};

export const UserContentReviewNotifyFormMainSection: React.FC<
  IUserContentReviewNotifyFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('UserContentReviewNotifyFormMainSection.fields.date.label')}
        required
      >
        <FormDateField
          name="date"
          control={form.control}
          defaultValue={new Date().toISOString()}
        />
      </Labeled>
      <Labeled
        label={t('UserContentReviewNotifyFormMainSection.fields.title.label')}
        supportingText={t(
          'UserContentReviewNotifyFormMainSection.fields.title.supportingText',
        )}
      >
        <FormField
          name="title"
          control={form.control}
          as={TextInputField}
          forwardError
        />
      </Labeled>
      <Labeled
        label={t('UserContentReviewNotifyFormMainSection.fields.content.label')}
        supportingText={t(
          'UserContentReviewNotifyFormMainSection.fields.content.supportingText',
        )}
      >
        <FormField
          name="content"
          control={form.control}
          as={TextAreaField}
          style={{
            // This is a hack for TextAreaField to work in Firefox.
            // TODO: Remove this hack once fixed in @sixui/ui.
            whiteSpace: 'revert',
          }}
          forwardError
        />
      </Labeled>
    </FormSection>
  );
};
